// test2018
(2018 && 0);
